import type { AxiosResponse } from 'axios'
import type ResponseParserChain from '../ResponseParserChain'

export default class DivisionResponseParser {
  parse(response: AxiosResponse, chain: ResponseParserChain) {
    // server 端不响应内容
    const contentType = response.headers['content-type']
    if (!contentType) {
      return chain.doParse(response, chain)
    }

    // server 端响应的不是 application/json 协议
    if (contentType.indexOf('application/json') === -1) {
      return chain.doParse(response, chain)
    }

    // data为string时，兼容ie
    const { success, errorcode, data, errortext } = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
    if (success === true) {
      return chain.doParse(data, chain)
    } else {
      throw new Error(errortext)
    }
  }
}
